import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Locations_ds_empty_locations_count_by_warehouseId_widgetService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async get(inParams: { warehouseId?: number }): Promise<{ result?: { TotalCount?: number } }> {
    let url = `${environment.backendUrl}api/Locations/datasources/ds_empty_locations_count_by_warehouseId_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      warehouseId?: number    }) {
      return false;
    }
}
